/**
 * Airports the prediction pipeline runs for. Drives the airport selector on
 * the Predictions page (desktop) and the Airport board (phone/tablet), so the
 * two views always offer the same set.
 */
export const SUPPORTED_AIRPORTS = [
  { icao: 'EIDW', iata: 'DUB', name: 'Dublin (EIDW)', lat: 53.4213, lon: -6.2701, tz: 'Europe/Dublin' },
  { icao: 'LPPR', iata: 'OPO', name: 'Porto (LPPR)',  lat: 41.2421, lon: -8.6814, tz: 'Europe/Lisbon' },
  // Surface-covered neighbours of the two above (Pinewood hears Casement's
  // apron, Calçada Ovar's): on-ground and movement-derived arrivals/departures
  // only — no landing model, so no predictions.
  { icao: 'EIME', iata: null,  name: 'Baldonnel / Casement (EIME)', lat: 53.3017, lon: -6.4514, tz: 'Europe/Dublin' },
  { icao: 'LPOV', iata: null,  name: 'Ovar (LPOV)', lat: 40.9159, lon: -8.6459, tz: 'Europe/Lisbon' }
];

export function isSupportedAirport(icao) {
  return !!icao && SUPPORTED_AIRPORTS.some(a => a.icao === icao.toUpperCase());
}
